{
    "imageMetaTags": {
        "imgSrcWhiteListDomains": "https://images.philips.com",
        "cssShaWhiteList": "'sha256-zRov+xUGJ/uvnA8bUk72Bu/FQ7Uk11WaDIOM4b+hpX0=' "
    },
    "Enable": true
}